import React from 'react';
import Box from 'react-raster';
import ButtonLink from '../ButtonLink';
import Container from '../Container';

function Cta({ ctaLabel, ctaUrl, backgroundColour }) {
  return (
    <Container
      paddingBottom={[0, '40px']}
      paddingTop={[0, '125px']}
    >
      <Box cols={[6, 12]} textAlign={['left', 'center']}>
        <ButtonLink isWhite={backgroundColour === 'white'} label={ctaLabel} url={ctaUrl} />
      </Box>
    </Container>
  );
}

export default Cta;
